import api from '../api';
const axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  },
};

const BASE_URL = process.env.REACT_APP_API_URL;

const ReplyService = {
  create: async (data) => {
    try {
      return await api.post(`${BASE_URL}/replies`, data, axiosConfig);
    } catch (error) {
      console.log("Error in creating reply.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  update: async (id, data) => {
    try {
      return await api.put(`${BASE_URL}/replies/${id}`, data, axiosConfig);
    } catch (error) {
      console.log("Error in updating reply.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },
  delete: async (id) => {
    try {
      return await api.delete(`${BASE_URL}/replies/${id}`, axiosConfig);
    } catch (error) {
      console.log("Error in deleting reply.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },
  get: async (id) => {
    try {
      return await api.get(`${BASE_URL}/replies/${id}`, axiosConfig);
    } catch (error) {
      console.log("Error in getting reply detail.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },
  getAll: async (type) => {
    try {
      return await api.get(`${BASE_URL}/replies?type=${type}`, axiosConfig)
    } catch (error) {
      console.log("Error in getting replies", [error])
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  getByTicketId:async (id, type) => {
    try {
      return await api.get(`${BASE_URL}/replies/by-ticket/${id}?type=${type}`, axiosConfig)
    } catch (error) {
      console.log("Error in getting replies", [error])
      throw new Error(error.response?.data?.message || error.message);
    }
  }
}

export default ReplyService